module.exports = __webpack_public_path__ + "img/robert-piosek-1.25bdf766.jpg";